<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changePassManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào biểu tượng Người dùng ở góc phải màn hình, thì màn hình quản lý thông tin người dùng sẽ được hiển thị.</p>
                </div>
                <div><img src="/static\images\vi\newManual\changePassManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào nút [Đổi mật khẩu] từ menu bên trái màn hình, thì khung thay đổi mật khẩu sẽ được hiển thị bên phải.</p>
                    <p>③ Sau khi nhập vào các ô [Mật khẩu hiện tại], [Mật khẩu mới], [Mật khẩu mới (Xác nhận)], rồi nhấn nút [Lưu mật khẩu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/changePass_manual.vue